import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class CmsPage extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/cms/page'
    super(store, path)
  }
}
